module.exports = __webpack_public_path__ + "img/2.2c923e08.png";